<template>
  <div>
    <label
      v-if="title != 'hide'"
      v-bind:class="{
        'text-danger': current.errors && current.errors.lote,
      }"
      >{{ title }}</label>
    <v-select
      label="codigo_lote"
      v-model="lote_seleccionado"
      :disabled="disabled"
      :filterable="false"
      :options="lotes"
      @search="onSearch"
      @input="onChange"
      placeholder="Lotes..."
    >
      <template slot="no-options">lotes...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
        {{option.producto}} - {{ option.codigo_lote }} vence: {{ option.fecha_vence }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.codigo_lote }} {{ option.producto }} - {{option.fecha_vence}}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.lote"
      class="form-text text-danger"
      >{{ current.errors.lote }}</small>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    title: {
      type: String,
      default: "Lotes",
    },
  },
  mounted() {
    this.refreshData();
  },
  watch: {
    'current.producto': {
      handler(newVal) {
        if(newVal) {
          this.refreshData();
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      lotes: [],
      lote_seleccionado: "",
    };
  },
  methods: {
    change(event) {
      this.$emit("change", event);
    },
    refreshData() {
      let self = this;
      
      if (!self.current.producto){
        self.lotes = [];
        return;
      }

      DynamicService.fetch("cat", "producto-lote", {
        page: 1,
        producto: this.current.producto, // Filtro por producto (SKU)
      }).then((res) => {
        self.lotes = res.data.results || [];
      }).catch(error => {
        console.error('Error loading lotes:', error);
        self.lotes = [];
      });
    },
    onChange(event) {
      if (event) {
        this.$emit("change", event); 
      } else {
        this.$emit("change", null);
      }
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (!search || search.trim() === "" || search == null) {
        // Si no hay búsqueda, cargar todos los lotes del producto
        vm.refreshData();
        loading(false);
        return;
      }
       
      DynamicService.fetch("cat", "producto-lote", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
        producto: vm.current.producto, // Filtro por producto (SKU)
      }).then((res) => {
        vm.lotes = res.data || [];
        loading(false);
      }).catch(error => {
        vm.lotes = [];
        loading(false);
      });
    }, 350),
  },

};
</script>